export const DISCLOSURE_TWO_LINK =
  'https://quashed.co.nz/documents/Disclosure%20Two.pdf';
